module.exports = __webpack_public_path__ + "media/images/country_flags/co-2289d4a7078daa121fc3429a9daa2f3d.png";